<template>
    <div class="dropdown" :class="[{ 'selected' : selectedItems.length > 0 }, { 'active' : showDrop}]" v-clickout="closeDrop" v-if="items.length">
        <button class="dropdown__button" @click="showDrop = !showDrop">{{buttonTitle}}</button>
        <div class="dropdown__body">
            <label class="checkbox" v-for="item in items">
                <input class="checkbox__input" type="checkbox" name="checkbox" :value="item" v-model="selectedItems" />
                <span class="checkbox__in">
                    <span class="checkbox__text">{{item.Name}}</span>
                    <span class="checkbox__tick"></span>
                </span>
            </label>
        </div>
    </div>
</template>
<script>
    export default {
        props: {
            product: String,
            filterName: String,
            value: Array,
        },
        data() {
            return {
                showDrop: false,
                items: [],
                selectedItems: [],
                url: ''
            }
        },
        computed: {
            selectedIds() {
                return this.selectedItems.map(i => i.Id)
            },
            buttonTitle() {
                if (this.selectedItems.length == 0) return this.filterName
                return `${this.filterName} - ${this.selectedItems.length}`
            }
        },
        watch: {
            selectedItems() {
                this.$emit('input', this.selectedIds)
            }
        },
        methods: {
            closeDrop() {
                this.showDrop = false
            },
        },
        mounted() {
            var vm = this
            vm.url = `/umbraco/surface/product/get${vm.product}${vm.filterName.replace(' ', '')}`
            vm.doPost(vm.url, null, (data) => {
                vm.items = data
                vm.selectedItems = vm.items.filter(i => vm.value.includes(i.Id))
            })
        }
    }
</script>